import { render, staticRenderFns } from "./capNhatTinTuc.vue?vue&type=template&id=f6c262da&"
import script from "./capNhatTinTuc.vue?vue&type=script&lang=js&"
export * from "./capNhatTinTuc.vue?vue&type=script&lang=js&"
import style0 from "./capNhatTinTuc.vue?vue&type=style&index=0&id=f6c262da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports